import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {RiderService} from '../rider.service';
import {GridOptions} from 'ag-grid';
import {T2CardComponent} from '../../../trip2-theme/components/t2-card/t2-card.component';
import {ViewAttachmentFileComponent} from '../../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';
@Component({
    selector: 'app-rider-history',
    templateUrl: './rider-history.component.html',
    styleUrls: ['./rider-history.component.scss']
})
export class RiderHistoryComponent implements OnInit {
  @ViewChild('p') public popover: T2CardComponent;
  /**
   * grid object
   */
  private historyGrid: GridOptions;

  private description = '';
  private file: any;
  private base64textString: string;
  private isLoading = false;
  private errorMessage = '';
  @Input() riderid: number;
  constructor(protected  service: RiderService) {
    this.historyGrid = <GridOptions>{};
    this.historyGrid.enableColResize = true;
    this.configureGrid();
  }

  ngOnInit() {
    this.getHistory(this.riderid);
  }
  /**
   * add columns to grid
   */
  private configureGrid() {
    this.historyGrid.columnDefs = [
      {
        headerName: 'Date',
        field: 'date',
        colId: 'date',
        width: 80
      },
      {
        headerName: 'Time',
        field: 'time',
        colId: 'time',
        width: 40
      },
      {
        headerName: 'Description',
        field: 'description',
        colId: 'description',
        width: 200
      },
      {
        headerName: 'User',
        field: 'user',
        colId: 'user',
        width: 120
      },
      {
        headerName: 'Type',
        field: 'type',
        colId: 'type',
        width: 80
      },
      {
        headerName: 'File',
        field: 'attachfile',
        cellRendererFramework: ViewAttachmentFileComponent,
        colId: 'attachedFile',
        width: 30
      }
    ]
  }

  /**
   * this execute when the grid is ready
   * for resize columns to fit
   * @param grid
   */
  public onGridReady(grid) {
    grid.api.sizeColumnsToFit();
  }

  /**
   * retrieve data from server
   */
  private getHistory(riderid) {
    this.service.getRiderHistory(riderid).subscribe(
      data => {
        if (this.historyGrid) {
          if (this.historyGrid.api) {
            this.historyGrid.api.setRowData(data);
          }
        }
      }
    );
  }

  /**
   * this execute when file is selected
   */

  handleFileSelect(evt) {
    const files = evt.target.files;
    const file = files[0];

    this.file = file;

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.errorMessage = '';
  }

  /**
   * save the file on server
   */
  public saveAttachment() {
    if (this.file) {
      if (this.description !== '') {
        this.errorMessage = '';
        const data = {
          riderid: this.riderid,
          attachement: this.base64textString,
          mimetype: this.file.type,
          attachementname: this.description
        };

        this.tooglePopover();
        this.isLoading = true;
        this.service.addHistoryFile(data).subscribe(
          res => {
            this.getHistory(this.riderid);
            this.resetView();
            this.isLoading = false;
          },
          err => {this.showError(err); this.isLoading = false; }
        );
      } else {
        this.errorMessage = 'Description is required';
      }
    } else {
      this.errorMessage = 'Please select a file';
    }
  }

  /**
   * show error method
   */

  private showError(err) {
    this.tooglePopover();
  }

  /**
   * Toogle popover
   */
  private tooglePopover() {
    // if ( this.popover.isOpen() ) {
    //   this.popover.close()
    // } else {
    //   this.popover.open()
    // }
  }

  /**
   * this reset all values for the view
   */
  private resetView() {
    this.base64textString = '';
    this.file = null;
    this.description = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-history/rider-history.component.ts